import React from 'react';

const QCReportStatus = ({ statusinfo,cycleMasterId,getAdwordsData }) => { 
     
return (<div class="bg-white dark:bg-gray-900">
  <div class="mx-auto max-w-8xl mb-5">
    <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <div class="grid grid-cols-1 gap-px bg-gray-900/5 sm:grid-cols-6 lg:grid-cols-6 dark:bg-white/10">
        <div 
        onClick={() => getAdwordsData(cycleMasterId, 1, 'all')}
        class="bg-white px-4 py-6 cursor-pointer sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Total Products</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="underline text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.product_counts}</span>
          </p>
        </div>
        
        <div 
      onClick={() => getAdwordsData(cycleMasterId, 1, 'verified')}
      className="bg-white px-4 py-6 cursor-pointer sm:px-6 lg:px-8 dark:bg-gray-900">
        <p className="text-sm/6 font-medium text-gray-500 dark:text-gray-400">
            Verified Products
        </p>
        <p className="mt-2 flex flex-col items-baseline gap-y-1">
            <span className="underline text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {statusinfo.product_qc_count}
            </span>
            <span className="text-sm font-medium text-green-600">
            {((Number(statusinfo.product_qc_count) / Number(statusinfo.product_counts)) * 100).toFixed(1)}%
            </span>
        </p>
        </div>
        <div 
        onClick={() => getAdwordsData(cycleMasterId, 1, 'not verified')}
        className="bg-white px-4 py-6 cursor-pointer sm:px-6 lg:px-8 dark:bg-gray-900">
        <p className="text-sm/6 font-medium text-gray-500 dark:text-gray-400">
            Not verified Products
        </p>
        <p className="mt-2 flex flex-col items-baseline gap-y-1">
            <span className="underline text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {(Number(statusinfo.product_counts) - Number(statusinfo.product_qc_count))}
            </span>
            <span className="text-sm font-medium text-red-500">
            {(((Number(statusinfo.product_counts) - Number(statusinfo.product_qc_count)) / Number(statusinfo.product_counts)) * 100).toFixed(1)}%
            </span>
        </p>
        </div>
        <div class="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
          <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Total Titles</p>
          <p class="mt-2 flex items-baseline gap-x-2">
            <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{statusinfo.completed_ai_count}</span>
            <span class="text-sm text-gray-500 dark:text-gray-400"></span>
          </p>
        </div>
        <div className="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
        <p className="text-sm/6 font-medium text-gray-500 dark:text-gray-400">
            Verified Titles
        </p>
        <p className="mt-2 flex flex-col items-baseline gap-y-1">
            <span className="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {statusinfo.qc_verified_count}
            </span>
            <span className="text-sm font-medium text-green-600">
            {((Number(statusinfo.qc_verified_count) / Number(statusinfo.completed_ai_count)) * 100).toFixed(1)}%
            </span>
        </p>
        </div>

        <div className="bg-white px-4 py-6 sm:px-6 lg:px-8 dark:bg-gray-900">
        <p className="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Unverified Titles</p>
        <p className="mt-2 flex flex-col items-baseline gap-y-1">
        <span className="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {Number(statusinfo.completed_ai_count) - Number(statusinfo.qc_verified_count)}
        </span>
        <span className="text-sm font-medium text-red-500">
        {(
            ((Number(statusinfo.completed_ai_count) - Number(statusinfo.qc_verified_count)) /
            Number(statusinfo.completed_ai_count)) *
            100
            ).toFixed(1)}%
        </span>
        </p>
      </div>
      

         
      </div>
    </div>
  </div>
</div>)}

export default QCReportStatus;